/*
 * Public API Surface of animation
 */

export * from './lib/animation.service';
export * from './lib/animation.component';
export * from './lib/animation.module';
export * from './lib/index';
